import { render, staticRenderFns } from "./NotificationsGroup.vue?vue&type=template&id=37ddb72a&scoped=true"
import script from "./NotificationsGroup.vue?vue&type=script&lang=js"
export * from "./NotificationsGroup.vue?vue&type=script&lang=js"
import style0 from "./NotificationsGroup.vue?vue&type=style&index=0&id=37ddb72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ddb72a",
  null
  
)

export default component.exports